<template>
  <div>
    <AhaInfoBox>
      <span>Not sure how a Quiz works?</span> Check out <a
        href="https://help.ahaslides.com/portal/ahaslides/en/kb/articles/how-to-make-and-run-a-quiz"
        target="_blank"
        class="right-col--link pl-0.5 whitespace-nowrap"
        @click="trackIt()"
      >
        our guide. <aha-svg
          name="open-new-window"
          class="ml-1 mb-0.5 text-secondary-40"
          viewBox="0 0 24 24"
          height="14"
          width="14"
        /></a>
    </AhaInfoBox>
  </div>
</template>

<script>
import Util from '@/util'

export default {
  methods: {
    trackIt() {
      Util.gaTrackEvent(
        'Presentation Editor',
        'Quiz > Open quiz information',
        '',
      )
    },
  },
}
</script>
